import { CTA, CTASignIn } from '@components/cta';

import { isMobileDevice } from '@globalUtils/environment';

import { MobileNav, MobileNavHeader, NavBody, Navbar, NavbarLogo } from '@/components/ui/resizable-navbar';

export function NavbarSection() {
  return (
    <Navbar>
      {/* Desktop Navigation */}
      <NavBody>
        <NavbarLogo />

        <div className="flex items-center gap-4 mr-4">
          {!isMobileDevice() && (
            <>
              <CTA data-id="boton-1" />
              <CTASignIn />
            </>
          )}
        </div>
      </NavBody>

      {/* Mobile Navigation */}
      <MobileNav>
        <MobileNavHeader>
          <NavbarLogo />
          <div className="flex items-center gap-0 lg:gap-4 mr-4">
            {isMobileDevice() && (
              <>
                <CTA fullWidth={false} data-id="boton-2" />
                <CTASignIn />
              </>
            )}
          </div>
        </MobileNavHeader>
      </MobileNav>
    </Navbar>
  );
}
